import React from 'react'

export default ({ ...props }) => (
  <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M9.83252 9.0289L5.75252 5.00006L9.83252 0.971226C10.0385 0.767895 10.0575 0.416789 9.87452 0.186792C9.69152 -0.0432053 9.37552 -0.0632051 9.16852 0.140126L5.00052 4.25674L0.832516 0.140126C0.626516 -0.0632051 0.310516 -0.0432053 0.126516 0.186792C-0.0574837 0.416789 -0.0384837 0.766784 0.168516 0.971226L4.24852 5.00006L0.168516 9.0289C-0.0374837 9.23223 -0.0564837 9.58334 0.126516 9.81334C0.225516 9.93667 0.362516 10 0.500516 10C0.618516 10 0.737516 9.95333 0.832516 9.86L5.00052 5.74339L9.16852 9.86C9.26352 9.95445 9.38252 10 9.50052 10C9.63852 10 9.77552 9.93667 9.87452 9.81334C10.0575 9.58445 10.0395 9.23334 9.83252 9.0289Z'
      fill='#0D0D0D'
    />
  </svg>
)
